/**
 * Заголовок разговоров выбранной корзины ряда и «Весь период» — над списком
 * раскрытой строки (`VoiceRowDetails`) и кода возражения (`ObjectionCodeCard`).
 */
import { useTranslation } from 'react-i18next';
import { CONTROL_MIN_HEIGHT } from '@/components/ui/control-size';
import { cn } from '@/lib/utils';

interface VoiceBucketHeaderProps {
  /** Корзина словами (`useTrendBucket`). */
  period: string;
  onClear: () => void;
}

export function VoiceBucketHeader({ period, onClear }: VoiceBucketHeaderProps) {
  const { t } = useTranslation('dashboard');
  return (
    <div className="flex flex-wrap items-center justify-between gap-2">
      <p className="text-xs font-medium text-fg-muted">
        {t('voicePage.series.bucketCalls', { period })}
      </p>
      <button
        type="button"
        className={cn(
          CONTROL_MIN_HEIGHT.sm,
          'inline-flex items-center rounded-sm text-xs text-primary transition-colors hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring'
        )}
        onClick={onClear}
      >
        {t('voicePage.series.bucketClear')}
      </button>
    </div>
  );
}
